<ng-container *ngIf="verified; else toValidate">
  <mat-icon color="primary"> verified</mat-icon>
</ng-container>

<ng-template #toValidate>
  <button mat-icon-button color="warn" aria-label="Indirizzo da validare" (click)="verify.emit()">
    <mat-icon>dangerous</mat-icon>
  </button>
</ng-template>
